var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('Navbar',{attrs:{"newSearchButtonActive":_vm.newSearchButtonVisible},on:{"newSearch":_vm.onNewSearchClicked}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }